export default {
    CREATE: "create",
    EDIT: "edit",
    DUPLICATE: "duplicate"
};
